import React from 'react'
import PropTypes from 'prop-types'
import { Query } from 'react-apollo'

import withStyles from 'material-ui/styles/withStyles'
import Tab from 'material-ui/Tabs/Tab'
import Tabs from 'material-ui/Tabs'
import statsClassificaAppuntamentiProposte from '../../graphql/queries/statsClassificaAppuntamentiProposte'
import GridContainer from 'components/Grid/GridContainer.jsx'
import ItemGrid from 'components/Grid/ItemGrid.jsx'
import Select from 'material-ui/Select'
import MenuItem from 'material-ui/Menu/MenuItem'
import PlayArrow from 'material-ui-icons/PlayArrow'

import classificaStyle from '../../assets/jss/material-dashboard-pro-react/components/classificaStyle'

class Classifica extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      active: props.active,
      classificaTipo: 'appuntamenti',
      rangeAppuntamenti: 'oggi',
      rangeProposte: 'mese',
    }
  }

  selectItems = {
    appuntamenti: ['oggi', 'settimana', 'mese', 'anno'],
    proposte: ['giorni30', 'giorni90', 'mese', 'anno'],
  }

  setClassificaTipo = (tipo, range) => {
    if (!this.selectItems[tipo].includes(range)) {
      return this.setState({ classificaTipo: tipo, range: 'mese' })
    } else return this.setState({ classificaTipo: tipo })
  }
  setRange = (range) => {
    if (this.state.classificaTipo === 'appuntamenti') {
      return this.setState({ rangeAppuntamenti: range })
    } else return this.setState({ rangeProposte: range })
  }
  handleChange = (event, active) => {
    this.setState({ active })
  }
  handleChangeIndex = (index) => {
    this.setState({ active: index })
  }
  render() {
    const { classes, me } = this.props

    return (
      <Query query={statsClassificaAppuntamentiProposte} variables={{ range: this.state.classificaTipo === 'appuntamenti' ? this.state.rangeAppuntamenti : this.state.rangeProposte, type: this.state.classificaTipo }} fetchPolicy="cache-and-network">
        {({ loading, error, data }) => {
          if (data.statsClassificaAppuntamentiProposteAgenti) {
            const part1 = data.statsClassificaAppuntamentiProposteAgenti.slice(0, Math.ceil(data.statsClassificaAppuntamentiProposteAgenti.length / 2))
            const part2 = data.statsClassificaAppuntamentiProposteAgenti.slice(Math.ceil(data.statsClassificaAppuntamentiProposteAgenti.length / 2))
            return (
              <div style={{ paddingRight: '15px', maxWidth: '1024px' }}>
                <div className="tabs-container">
                  <Tabs value={this.state.classificaTipo} onChange={(a, val) => this.setClassificaTipo(val, this.state.range)} indicatorClassName={classes.displayNone} classes={{ root: classes.tabRoot }}>
                    <Tab label={'Appuntamenti'} key={'appuntamenti'} value={'appuntamenti'} classes={{ rootInheritSelected: classes.active }} />
                    <Tab label={'Proposte'} key={'proposte'} value={'proposte'} classes={{ rootInheritSelected: classes.active }} />
                  </Tabs>
                  {this.state.classificaTipo === 'appuntamenti' && (
                    <Select
                      className="select"
                      label="Range"
                      classes={{ root: classes.selectInput }}
                      value={this.state.rangeAppuntamenti}
                      onChange={(event) => this.setRange(event.target.value)}
                      inputProps={{
                        name: 'simpleSelect',
                        id: 'simple-select',
                      }}
                    >
                      <MenuItem value={'oggi'}>Oggi</MenuItem>
                      <MenuItem value={'settimana'}>Ultimi 7 giorni</MenuItem>
                      <MenuItem value={'mese'}>Questo mese</MenuItem>
                      {(me.ruolo === 'ADMIN' || me.mostraStatisticheAgenti) && <MenuItem value={'anno'}>Ultimo anno</MenuItem>}
                    </Select>
                  )}
                  {this.state.classificaTipo === 'proposte' && (
                    <Select
                      placeholder={this.state.rangeProposte}
                      className="select"
                      label="Range"
                      classes={{ root: classes.selectInput }}
                      value={this.state.rangeProposte}
                      onChange={(event) => this.setRange(event.target.value)}
                      inputProps={{
                        name: 'simpleSelect',
                        id: 'simple-select',
                      }}
                    >
                      <MenuItem value={'giorni30'}>Ultimi 30 giorni</MenuItem>
                      <MenuItem value={'giorni90'}>Ultimi 90 giorni</MenuItem>
                      <MenuItem value={'mese'}>Questo mese</MenuItem>
                      {(me.ruolo === 'ADMIN' || me.mostraStatisticheAgenti) && <MenuItem value={'anno'}>Ultimo anno</MenuItem>}
                    </Select>
                  )}
                </div>
                <div className="classifica-container">
                  {this.state.classificaTipo === 'appuntamenti' && (
                    <Select
                      className="select-mobile"
                      label="Range"
                      classes={{ root: classes.selectInput }}
                      value={this.state.rangeAppuntamenti}
                      onChange={(event) => this.setRange(event.target.value)}
                      inputProps={{
                        name: 'simpleSelect',
                        id: 'simple-select',
                      }}
                    >
                      <MenuItem value={'oggi'}>Oggi</MenuItem>
                      <MenuItem value={'settimana'}>Ultimi 7 giorni</MenuItem>
                      <MenuItem value={'mese'}>Questo mese</MenuItem>
                      {(me.ruolo === 'ADMIN' || me.mostraStatisticheAgenti) && <MenuItem value={'anno'}>Ultimo anno</MenuItem>}
                    </Select>
                  )}
                  {this.state.classificaTipo === 'proposte' && (
                    <Select
                      className="select-mobile"
                      label="Range"
                      classes={{ root: classes.selectInput }}
                      value={this.state.rangeProposte}
                      onChange={(event) => this.setRange(event.target.value)}
                      inputProps={{
                        name: 'simpleSelect',
                        id: 'simple-select',
                      }}
                    >
                      <MenuItem value={'giorni30'}>Ultimi 30 giorni</MenuItem>
                      <MenuItem value={'giorni90'}>Ultimi 90 giorni</MenuItem>
                      <MenuItem value={'mese'}>Questo mese</MenuItem>
                      {(me.ruolo === 'ADMIN' || me.mostraStatisticheAgenti) && <MenuItem value={'anno'}>Ultimo anno</MenuItem>}
                    </Select>
                  )}
                  <GridContainer className="gap">
                    <ItemGrid xs={12} sm={6} md={6} lg={6} className="item-container">
                      {part1.map((agente, index) => {
                        return (
                          <div className={me.nome === agente.nome ? 'classifica-item me' : 'classifica-item'} key={agente.nome}>
                            <div className="relative">
                              {me.nome === agente.nome && <PlayArrow className={me.mostraStatisticheAgenti ? 'play-arrow2' : 'play-arrow1'} />}
                              <span style={{ fontWeight: 500 }}>{index + 1}. &nbsp;</span>
                              <span>{agente.nome}</span>
                            </div>
                            <p>{agente.count}</p>
                          </div>
                        )
                      })}
                    </ItemGrid>
                    <ItemGrid xs={12} sm={6} md={6} lg={6} className="item-container2">
                      {part2.map((agente, index) => {
                        return (
                          <div key={agente.nome} className={me.nome === agente.nome ? 'classifica-item me' : 'classifica-item'}>
                            <div className="relative">
                              {me.nome === agente.nome && <PlayArrow className={me.mostraStatisticheAgenti ? 'play-arrow2' : 'play-arrow1'} />}
                              <span style={{ fontWeight: 500 }}>{Math.ceil(data.statsClassificaAppuntamentiProposteAgenti.length / 2) + index + 1}. &nbsp;</span>
                              <span>{agente.nome} </span>
                            </div>
                            <p>{agente.count}</p>
                          </div>
                        )
                      })}
                    </ItemGrid>
                  </GridContainer>
                </div>
              </div>
            )
          } else return null
        }}
      </Query>
    )
  }
}

Classifica.defaultProps = {
  active: 0,
  color: 'primary',
}

Classifica.propTypes = {
  classes: PropTypes.object.isRequired,
  active: PropTypes.number,
  color: PropTypes.oneOf(['primary', 'warning', 'danger', 'success', 'info', 'rose']),
  direction: PropTypes.string,
  horizontal: PropTypes.shape({
    tabsGrid: PropTypes.object,
    contentGrid: PropTypes.object,
  }),
  alignCenter: PropTypes.bool,
}

export default withStyles(classificaStyle)(Classifica)



// WEBPACK FOOTER //
// ./src/components/Classifica/Classifica.jsx